import { useEffect, useState } from "react";

/* 개발 사례 — SSTOA 에서 공개로 설정한 것만 /api/works 로 내려온다.
   여러 화면(홈 · /works)이 같은 목록을 쓰므로 한 번 받은 결과를 페이지 이동 사이에 재사용한다. */
let cache = null;

export function useWorks() {
  const [state, setState] = useState(() => (cache ? { items: cache, status: "ok" } : { items: [], status: "loading" }));

  useEffect(() => {
    let alive = true;
    fetch("/api/works")
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error(String(r.status)))))
      .then((data) => {
        cache = data.items || [];
        if (alive) setState({ items: cache, status: "ok" });
      })
      .catch(() => {
        if (alive) setState((s) => ({ items: s.items, status: s.items.length ? "ok" : "error" }));
      });
    return () => { alive = false; };
  }, []);

  return state;
}
